import React, { useEffect, useState } from 'react';
import styles from './QuestionNode.module.scss';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useEdges, useNodes } from '@xyflow/react';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import QuestionModal from './question-modal/QuestionModal';

const QuestionNode = ({ id, isConnectable, selected }) => {
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);
  const edges = useEdges();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState(node?.is_Error || false);

  const connectedEdges = edges.filter(
    (edge) => edge.source === id || edge.target === id
  );
  const isAnyQuestionTextEmpty = node?.question?.some(
    (item) => item.questionText.trim() === ''
  );
  useEffect(() => {
    if (node?.question != undefined) {
      if (isAnyQuestionTextEmpty) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [node?.question]);

  return (
    <>
      <NodeContainer
        name={node?.title ?? 'Question Block'}
        id={id}
        onClick={() => setIsModalOpen(true)}
        backgroundColor={node?.color}
        selected={selected}
        node={node}
        isError={isError}
      >
        <Handle
          type="target"
          position={Position.Left}
          className="custom-handle"
        />

        <div className={styles['questions-cont']}>
          {node?.question === undefined ? (
            <div className={styles.question}>
              <div className={styles.svg}>
                <SvgWithBranding
                  type="node-question"
                  color="#787878"
                  className={styles.deleteIcon}
                />
                <p className={styles.placeholder}>Enter a question</p>
              </div>
            </div>
          ) : (
            node?.question?.map((item, index) => (
              <div key={item.id} className={styles.question} id={item.id}>
                <div className={styles.svg}>
                  <SvgWithBranding
                    type="node-question"
                    color="#787878"
                    className={styles.deleteIcon}
                  />
                  {item.questionText ? (
                    <p>{item.questionText}</p>
                  ) : (
                    <p className={styles.placeholder}>Enter a question</p>
                  )}
                </div>
                <Handle
                  type="source"
                  position={Position.Right}
                  id={
                    node?.questions?.length == 1
                      ? `source-${id}-default`
                      : `source-${id}-${index}`
                  }
                  sourceHandle={
                    node?.question?.length == 1
                      ? `source-${id}-default`
                      : `source-${id}-${index}`
                  }
                  className="custom-handle"
                  style={{
                    top: node?.question?.length == 1 ? 20 + index : 10 + index,
                    position: 'absolute',
                  }}
                  isConnectable={isConnectable}
                />
              </div>
            ))
          )}
        </div>
      </NodeContainer>
      <QuestionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Question"
        id={id}
        isError={isError}
      />
    </>
  );
};

export default QuestionNode;
